import { UserProfileForm } from "@/components/layout/nav-user-dropdown/user-details/UserProfileForm";
import { SETTINGS_TABLE_WRAPPER } from "@/pages/settings/settings-layout-constants";

export function SettingsProfilePage() {
  return (
    <div className="flex flex-col gap-6">
      <div className={SETTINGS_TABLE_WRAPPER}>
        <div className="p-6">
          <UserProfileForm />
        </div>
      </div>
    </div>
  );
}
